export default __webpack_public_path__ + "static/media/machine_learning.c33e50c3.jpeg";